export interface PhoneCountryCode {
  /** E.164 prefix, e.g. +91 */
  code: string;
  /** Country or territory name */
  country: string;
  /** Option label for selects */
  label: string;
}

/** Default for Peppar (India-first product). */
export const DEFAULT_PHONE_COUNTRY_CODE = '+91';

/**
 * International dialing codes for contact / demo forms.
 * India is listed first; remaining entries are alphabetical by country name.
 */
const REST_OF_WORLD: PhoneCountryCode[] = [
  { code: '+93', country: 'Afghanistan', label: 'Afghanistan (+93)' },
  { code: '+355', country: 'Albania', label: 'Albania (+355)' },
  { code: '+213', country: 'Algeria', label: 'Algeria (+213)' },
  { code: '+1684', country: 'American Samoa', label: 'American Samoa (+1684)' },
  { code: '+376', country: 'Andorra', label: 'Andorra (+376)' },
  { code: '+244', country: 'Angola', label: 'Angola (+244)' },
  { code: '+1264', country: 'Anguilla', label: 'Anguilla (+1264)' },
  { code: '+1268', country: 'Antigua and Barbuda', label: 'Antigua and Barbuda (+1268)' },
  { code: '+54', country: 'Argentina', label: 'Argentina (+54)' },
  { code: '+374', country: 'Armenia', label: 'Armenia (+374)' },
  { code: '+297', country: 'Aruba', label: 'Aruba (+297)' },
  { code: '+61', country: 'Australia', label: 'Australia (+61)' },
  { code: '+43', country: 'Austria', label: 'Austria (+43)' },
  { code: '+994', country: 'Azerbaijan', label: 'Azerbaijan (+994)' },
  { code: '+1242', country: 'Bahamas', label: 'Bahamas (+1242)' },
  { code: '+973', country: 'Bahrain', label: 'Bahrain (+973)' },
  { code: '+880', country: 'Bangladesh', label: 'Bangladesh (+880)' },
  { code: '+1246', country: 'Barbados', label: 'Barbados (+1246)' },
  { code: '+375', country: 'Belarus', label: 'Belarus (+375)' },
  { code: '+32', country: 'Belgium', label: 'Belgium (+32)' },
  { code: '+501', country: 'Belize', label: 'Belize (+501)' },
  { code: '+229', country: 'Benin', label: 'Benin (+229)' },
  { code: '+1441', country: 'Bermuda', label: 'Bermuda (+1441)' },
  { code: '+975', country: 'Bhutan', label: 'Bhutan (+975)' },
  { code: '+591', country: 'Bolivia', label: 'Bolivia (+591)' },
  { code: '+387', country: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina (+387)' },
  { code: '+267', country: 'Botswana', label: 'Botswana (+267)' },
  { code: '+55', country: 'Brazil', label: 'Brazil (+55)' },
  { code: '+673', country: 'Brunei', label: 'Brunei (+673)' },
  { code: '+359', country: 'Bulgaria', label: 'Bulgaria (+359)' },
  { code: '+226', country: 'Burkina Faso', label: 'Burkina Faso (+226)' },
  { code: '+257', country: 'Burundi', label: 'Burundi (+257)' },
  { code: '+855', country: 'Cambodia', label: 'Cambodia (+855)' },
  { code: '+237', country: 'Cameroon', label: 'Cameroon (+237)' },
  { code: '+1', country: 'Canada', label: 'Canada (+1)' },
  { code: '+238', country: 'Cape Verde', label: 'Cape Verde (+238)' },
  { code: '+1345', country: 'Cayman Islands', label: 'Cayman Islands (+1345)' },
  { code: '+236', country: 'Central African Republic', label: 'Central African Republic (+236)' },
  { code: '+235', country: 'Chad', label: 'Chad (+235)' },
  { code: '+56', country: 'Chile', label: 'Chile (+56)' },
  { code: '+86', country: 'China', label: 'China (+86)' },
  { code: '+57', country: 'Colombia', label: 'Colombia (+57)' },
  { code: '+269', country: 'Comoros', label: 'Comoros (+269)' },
  { code: '+242', country: 'Congo', label: 'Congo (+242)' },
  { code: '+243', country: 'Congo (DRC)', label: 'Congo (DRC) (+243)' },
  { code: '+682', country: 'Cook Islands', label: 'Cook Islands (+682)' },
  { code: '+506', country: 'Costa Rica', label: 'Costa Rica (+506)' },
  { code: '+225', country: "Côte d'Ivoire", label: "Côte d'Ivoire (+225)" },
  { code: '+385', country: 'Croatia', label: 'Croatia (+385)' },
  { code: '+53', country: 'Cuba', label: 'Cuba (+53)' },
  { code: '+599', country: 'Curaçao', label: 'Curaçao (+599)' },
  { code: '+357', country: 'Cyprus', label: 'Cyprus (+357)' },
  { code: '+420', country: 'Czech Republic', label: 'Czech Republic (+420)' },
  { code: '+45', country: 'Denmark', label: 'Denmark (+45)' },
  { code: '+253', country: 'Djibouti', label: 'Djibouti (+253)' },
  { code: '+1767', country: 'Dominica', label: 'Dominica (+1767)' },
  { code: '+1809', country: 'Dominican Republic', label: 'Dominican Republic (+1809)' },
  { code: '+593', country: 'Ecuador', label: 'Ecuador (+593)' },
  { code: '+20', country: 'Egypt', label: 'Egypt (+20)' },
  { code: '+503', country: 'El Salvador', label: 'El Salvador (+503)' },
  { code: '+240', country: 'Equatorial Guinea', label: 'Equatorial Guinea (+240)' },
  { code: '+291', country: 'Eritrea', label: 'Eritrea (+291)' },
  { code: '+372', country: 'Estonia', label: 'Estonia (+372)' },
  { code: '+268', country: 'Eswatini', label: 'Eswatini (+268)' },
  { code: '+251', country: 'Ethiopia', label: 'Ethiopia (+251)' },
  { code: '+500', country: 'Falkland Islands', label: 'Falkland Islands (+500)' },
  { code: '+298', country: 'Faroe Islands', label: 'Faroe Islands (+298)' },
  { code: '+679', country: 'Fiji', label: 'Fiji (+679)' },
  { code: '+358', country: 'Finland', label: 'Finland (+358)' },
  { code: '+33', country: 'France', label: 'France (+33)' },
  { code: '+594', country: 'French Guiana', label: 'French Guiana (+594)' },
  { code: '+689', country: 'French Polynesia', label: 'French Polynesia (+689)' },
  { code: '+241', country: 'Gabon', label: 'Gabon (+241)' },
  { code: '+220', country: 'Gambia', label: 'Gambia (+220)' },
  { code: '+995', country: 'Georgia', label: 'Georgia (+995)' },
  { code: '+49', country: 'Germany', label: 'Germany (+49)' },
  { code: '+233', country: 'Ghana', label: 'Ghana (+233)' },
  { code: '+350', country: 'Gibraltar', label: 'Gibraltar (+350)' },
  { code: '+30', country: 'Greece', label: 'Greece (+30)' },
  { code: '+299', country: 'Greenland', label: 'Greenland (+299)' },
  { code: '+1473', country: 'Grenada', label: 'Grenada (+1473)' },
  { code: '+590', country: 'Guadeloupe', label: 'Guadeloupe (+590)' },
  { code: '+1671', country: 'Guam', label: 'Guam (+1671)' },
  { code: '+502', country: 'Guatemala', label: 'Guatemala (+502)' },
  { code: '+224', country: 'Guinea', label: 'Guinea (+224)' },
  { code: '+245', country: 'Guinea-Bissau', label: 'Guinea-Bissau (+245)' },
  { code: '+592', country: 'Guyana', label: 'Guyana (+592)' },
  { code: '+509', country: 'Haiti', label: 'Haiti (+509)' },
  { code: '+504', country: 'Honduras', label: 'Honduras (+504)' },
  { code: '+852', country: 'Hong Kong', label: 'Hong Kong (+852)' },
  { code: '+36', country: 'Hungary', label: 'Hungary (+36)' },
  { code: '+354', country: 'Iceland', label: 'Iceland (+354)' },
  { code: '+62', country: 'Indonesia', label: 'Indonesia (+62)' },
  { code: '+98', country: 'Iran', label: 'Iran (+98)' },
  { code: '+964', country: 'Iraq', label: 'Iraq (+964)' },
  { code: '+353', country: 'Ireland', label: 'Ireland (+353)' },
  { code: '+972', country: 'Israel', label: 'Israel (+972)' },
  { code: '+39', country: 'Italy', label: 'Italy (+39)' },
  { code: '+1876', country: 'Jamaica', label: 'Jamaica (+1876)' },
  { code: '+81', country: 'Japan', label: 'Japan (+81)' },
  { code: '+962', country: 'Jordan', label: 'Jordan (+962)' },
  { code: '+7', country: 'Kazakhstan', label: 'Kazakhstan (+7)' },
  { code: '+254', country: 'Kenya', label: 'Kenya (+254)' },
  { code: '+686', country: 'Kiribati', label: 'Kiribati (+686)' },
  { code: '+383', country: 'Kosovo', label: 'Kosovo (+383)' },
  { code: '+965', country: 'Kuwait', label: 'Kuwait (+965)' },
  { code: '+996', country: 'Kyrgyzstan', label: 'Kyrgyzstan (+996)' },
  { code: '+856', country: 'Laos', label: 'Laos (+856)' },
  { code: '+371', country: 'Latvia', label: 'Latvia (+371)' },
  { code: '+961', country: 'Lebanon', label: 'Lebanon (+961)' },
  { code: '+266', country: 'Lesotho', label: 'Lesotho (+266)' },
  { code: '+231', country: 'Liberia', label: 'Liberia (+231)' },
  { code: '+218', country: 'Libya', label: 'Libya (+218)' },
  { code: '+423', country: 'Liechtenstein', label: 'Liechtenstein (+423)' },
  { code: '+370', country: 'Lithuania', label: 'Lithuania (+370)' },
  { code: '+352', country: 'Luxembourg', label: 'Luxembourg (+352)' },
  { code: '+853', country: 'Macau', label: 'Macau (+853)' },
  { code: '+261', country: 'Madagascar', label: 'Madagascar (+261)' },
  { code: '+265', country: 'Malawi', label: 'Malawi (+265)' },
  { code: '+60', country: 'Malaysia', label: 'Malaysia (+60)' },
  { code: '+960', country: 'Maldives', label: 'Maldives (+960)' },
  { code: '+223', country: 'Mali', label: 'Mali (+223)' },
  { code: '+356', country: 'Malta', label: 'Malta (+356)' },
  { code: '+692', country: 'Marshall Islands', label: 'Marshall Islands (+692)' },
  { code: '+596', country: 'Martinique', label: 'Martinique (+596)' },
  { code: '+222', country: 'Mauritania', label: 'Mauritania (+222)' },
  { code: '+230', country: 'Mauritius', label: 'Mauritius (+230)' },
  { code: '+262', country: 'Mayotte', label: 'Mayotte (+262)' },
  { code: '+52', country: 'Mexico', label: 'Mexico (+52)' },
  { code: '+691', country: 'Micronesia', label: 'Micronesia (+691)' },
  { code: '+373', country: 'Moldova', label: 'Moldova (+373)' },
  { code: '+377', country: 'Monaco', label: 'Monaco (+377)' },
  { code: '+976', country: 'Mongolia', label: 'Mongolia (+976)' },
  { code: '+382', country: 'Montenegro', label: 'Montenegro (+382)' },
  { code: '+1664', country: 'Montserrat', label: 'Montserrat (+1664)' },
  { code: '+212', country: 'Morocco', label: 'Morocco (+212)' },
  { code: '+258', country: 'Mozambique', label: 'Mozambique (+258)' },
  { code: '+95', country: 'Myanmar', label: 'Myanmar (+95)' },
  { code: '+264', country: 'Namibia', label: 'Namibia (+264)' },
  { code: '+674', country: 'Nauru', label: 'Nauru (+674)' },
  { code: '+977', country: 'Nepal', label: 'Nepal (+977)' },
  { code: '+31', country: 'Netherlands', label: 'Netherlands (+31)' },
  { code: '+687', country: 'New Caledonia', label: 'New Caledonia (+687)' },
  { code: '+64', country: 'New Zealand', label: 'New Zealand (+64)' },
  { code: '+505', country: 'Nicaragua', label: 'Nicaragua (+505)' },
  { code: '+227', country: 'Niger', label: 'Niger (+227)' },
  { code: '+234', country: 'Nigeria', label: 'Nigeria (+234)' },
  { code: '+683', country: 'Niue', label: 'Niue (+683)' },
  { code: '+672', country: 'Norfolk Island', label: 'Norfolk Island (+672)' },
  { code: '+850', country: 'North Korea', label: 'North Korea (+850)' },
  { code: '+389', country: 'North Macedonia', label: 'North Macedonia (+389)' },
  { code: '+1670', country: 'Northern Mariana Islands', label: 'Northern Mariana Islands (+1670)' },
  { code: '+47', country: 'Norway', label: 'Norway (+47)' },
  { code: '+968', country: 'Oman', label: 'Oman (+968)' },
  { code: '+92', country: 'Pakistan', label: 'Pakistan (+92)' },
  { code: '+680', country: 'Palau', label: 'Palau (+680)' },
  { code: '+970', country: 'Palestine', label: 'Palestine (+970)' },
  { code: '+507', country: 'Panama', label: 'Panama (+507)' },
  { code: '+675', country: 'Papua New Guinea', label: 'Papua New Guinea (+675)' },
  { code: '+595', country: 'Paraguay', label: 'Paraguay (+595)' },
  { code: '+51', country: 'Peru', label: 'Peru (+51)' },
  { code: '+63', country: 'Philippines', label: 'Philippines (+63)' },
  { code: '+48', country: 'Poland', label: 'Poland (+48)' },
  { code: '+351', country: 'Portugal', label: 'Portugal (+351)' },
  { code: '+1787', country: 'Puerto Rico', label: 'Puerto Rico (+1787)' },
  { code: '+974', country: 'Qatar', label: 'Qatar (+974)' },
  { code: '+262', country: 'Réunion', label: 'Réunion (+262)' },
  { code: '+40', country: 'Romania', label: 'Romania (+40)' },
  { code: '+7', country: 'Russia', label: 'Russia (+7)' },
  { code: '+250', country: 'Rwanda', label: 'Rwanda (+250)' },
  { code: '+590', country: 'Saint Barthélemy', label: 'Saint Barthélemy (+590)' },
  { code: '+290', country: 'Saint Helena', label: 'Saint Helena (+290)' },
  { code: '+1869', country: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis (+1869)' },
  { code: '+1758', country: 'Saint Lucia', label: 'Saint Lucia (+1758)' },
  { code: '+590', country: 'Saint Martin', label: 'Saint Martin (+590)' },
  { code: '+508', country: 'Saint Pierre and Miquelon', label: 'Saint Pierre and Miquelon (+508)' },
  { code: '+1784', country: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines (+1784)' },
  { code: '+685', country: 'Samoa', label: 'Samoa (+685)' },
  { code: '+378', country: 'San Marino', label: 'San Marino (+378)' },
  { code: '+239', country: 'São Tomé and Príncipe', label: 'São Tomé and Príncipe (+239)' },
  { code: '+966', country: 'Saudi Arabia', label: 'Saudi Arabia (+966)' },
  { code: '+221', country: 'Senegal', label: 'Senegal (+221)' },
  { code: '+381', country: 'Serbia', label: 'Serbia (+381)' },
  { code: '+248', country: 'Seychelles', label: 'Seychelles (+248)' },
  { code: '+232', country: 'Sierra Leone', label: 'Sierra Leone (+232)' },
  { code: '+65', country: 'Singapore', label: 'Singapore (+65)' },
  { code: '+1721', country: 'Sint Maarten', label: 'Sint Maarten (+1721)' },
  { code: '+421', country: 'Slovakia', label: 'Slovakia (+421)' },
  { code: '+386', country: 'Slovenia', label: 'Slovenia (+386)' },
  { code: '+677', country: 'Solomon Islands', label: 'Solomon Islands (+677)' },
  { code: '+252', country: 'Somalia', label: 'Somalia (+252)' },
  { code: '+27', country: 'South Africa', label: 'South Africa (+27)' },
  { code: '+82', country: 'South Korea', label: 'South Korea (+82)' },
  { code: '+211', country: 'South Sudan', label: 'South Sudan (+211)' },
  { code: '+34', country: 'Spain', label: 'Spain (+34)' },
  { code: '+94', country: 'Sri Lanka', label: 'Sri Lanka (+94)' },
  { code: '+249', country: 'Sudan', label: 'Sudan (+249)' },
  { code: '+597', country: 'Suriname', label: 'Suriname (+597)' },
  { code: '+46', country: 'Sweden', label: 'Sweden (+46)' },
  { code: '+41', country: 'Switzerland', label: 'Switzerland (+41)' },
  { code: '+963', country: 'Syria', label: 'Syria (+963)' },
  { code: '+886', country: 'Taiwan', label: 'Taiwan (+886)' },
  { code: '+992', country: 'Tajikistan', label: 'Tajikistan (+992)' },
  { code: '+255', country: 'Tanzania', label: 'Tanzania (+255)' },
  { code: '+66', country: 'Thailand', label: 'Thailand (+66)' },
  { code: '+670', country: 'Timor-Leste', label: 'Timor-Leste (+670)' },
  { code: '+228', country: 'Togo', label: 'Togo (+228)' },
  { code: '+690', country: 'Tokelau', label: 'Tokelau (+690)' },
  { code: '+676', country: 'Tonga', label: 'Tonga (+676)' },
  { code: '+1868', country: 'Trinidad and Tobago', label: 'Trinidad and Tobago (+1868)' },
  { code: '+216', country: 'Tunisia', label: 'Tunisia (+216)' },
  { code: '+90', country: 'Turkey', label: 'Turkey (+90)' },
  { code: '+993', country: 'Turkmenistan', label: 'Turkmenistan (+993)' },
  { code: '+1649', country: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands (+1649)' },
  { code: '+688', country: 'Tuvalu', label: 'Tuvalu (+688)' },
  { code: '+256', country: 'Uganda', label: 'Uganda (+256)' },
  { code: '+380', country: 'Ukraine', label: 'Ukraine (+380)' },
  { code: '+971', country: 'United Arab Emirates', label: 'United Arab Emirates (+971)' },
  { code: '+44', country: 'United Kingdom', label: 'United Kingdom (+44)' },
  { code: '+1', country: 'United States', label: 'United States (+1)' },
  { code: '+598', country: 'Uruguay', label: 'Uruguay (+598)' },
  { code: '+998', country: 'Uzbekistan', label: 'Uzbekistan (+998)' },
  { code: '+678', country: 'Vanuatu', label: 'Vanuatu (+678)' },
  { code: '+379', country: 'Vatican City', label: 'Vatican City (+379)' },
  { code: '+58', country: 'Venezuela', label: 'Venezuela (+58)' },
  { code: '+84', country: 'Vietnam', label: 'Vietnam (+84)' },
  { code: '+1284', country: 'Virgin Islands (British)', label: 'Virgin Islands (British) (+1284)' },
  { code: '+1340', country: 'Virgin Islands (US)', label: 'Virgin Islands (US) (+1340)' },
  { code: '+681', country: 'Wallis and Futuna', label: 'Wallis and Futuna (+681)' },
  { code: '+967', country: 'Yemen', label: 'Yemen (+967)' },
  { code: '+260', country: 'Zambia', label: 'Zambia (+260)' },
  { code: '+263', country: 'Zimbabwe', label: 'Zimbabwe (+263)' },
];

export const PHONE_COUNTRY_CODES: PhoneCountryCode[] = [
  { code: '+91', country: 'India', label: 'India (+91)' },
  ...REST_OF_WORLD,
];

export function phonePlaceholder(countryCode: string): string {
  if (countryCode === '+91') return '9876543210';
  if (countryCode === '+1') return '5551234567';
  if (countryCode === '+44') return '7911123456';
  return 'Phone number';
}

export function validatePhoneNumber(localNumber: string, countryCode: string): string | null {
  const digits = localNumber.replace(/\D/g, '');
  if (!digits) return 'Phone number is required.';
  if (countryCode === '+91') {
    if (!/^[6-9]\d{9}$/.test(digits)) return 'Enter a valid 10-digit Indian mobile number.';
    return null;
  }
  if (digits.length < 6 || digits.length > 15) return 'Enter a valid phone number (6–15 digits).';
  return null;
}

export const DEFAULT_COUNTRY = 'India';

/** Country names for location selects (same list as demo / contact forms). */
export const PARTNER_COUNTRY_OPTIONS: string[] = PHONE_COUNTRY_CODES.map((c) => c.country);

export function buildFullPhone(countryCode: string, localNumber: string): string {
  return countryCode + localNumber.replace(/\D/g, '');
}

/** Split stored E.164 phone into country code + local digits for form fields. */
export function parseStoredPhone(full: string | undefined | null): { code: string; local: string } {
  const trimmed = (full || '').trim();
  if (!trimmed) {
    return { code: DEFAULT_PHONE_COUNTRY_CODE, local: '' };
  }
  const sorted = [...PHONE_COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  for (const entry of sorted) {
    if (trimmed.startsWith(entry.code)) {
      return { code: entry.code, local: trimmed.slice(entry.code.length).replace(/\D/g, '') };
    }
  }
  if (trimmed.startsWith('+')) {
    return { code: DEFAULT_PHONE_COUNTRY_CODE, local: trimmed.replace(/\D/g, '') };
  }
  return { code: DEFAULT_PHONE_COUNTRY_CODE, local: trimmed.replace(/\D/g, '') };
}
